<template>
	<ui-card icon="fal fa-calendar-alt" title="Data da Venda">
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<div class="internal-header">
					<h2 class="title">Quem pode visualizar?</h2>
					<span class="desc"
						>Selecione os perfis que podem visualizar a data das vendas.</span
					>
				</div>

				<ui-select-2
					v-model="form.editDate"
					:data="userGroups"
					:search="false"
					item-label="label"
					multiple
				/>

				<div class="internal-header line-t">
					<h2 class="title">Quem pode editar?</h2>
					<span class="desc"
						>Selecione os perfis que podem editar a data das vendas.</span
					>
				</div>

				<ui-select-2
					v-model="form.viewDate"
					:data="userGroups"
					:search="false"
					item-label="label"
					multiple
				/>

				<div class="internal-header line-t">
					<h2 class="title">Data de venda automática.</h2>
					<span class="desc"
						>Defina a possibilidade de editar a data das vendas automáticas.</span
					>
				</div>

				<ui-select-2
					v-model="form.automatic"
					:data="automaticOptions"
					:search="false"
					item-label="label"
					return-value="value"
				/>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { defaultOptionsUserGroups, selectUserList } from '../../util/functions'
	import { defaultAutomaticOptions } from './data'

	const userGroups = ['collaborator', 'supervisor', 'manager', 'broker']

	const defaultForm = () => ({
		closeDateDeal: null,
		viewDate: null,
		editDate: null,
		automatic: null,
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({
		ownerDuplicate: false,
		permissionDelete: false,
		permissionDeleteDeal: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-customers-sale-date',

		components: {
			uiCard,
			uiButton,
			uiSelect2,
			uiLoadSuccess,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				userGroups: [...defaultOptionsUserGroups(userGroups)],
				automaticOptions: [...defaultAutomaticOptions()],
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true
			const closeDateDeal = await this.getConfig('closeDateDeal', 'value_long')

			this.form.closeDateDeal = { ...closeDateDeal }
			this.form.viewDate = [...selectUserList(closeDateDeal.viewDate, userGroups)]
			this.form.editDate = [...selectUserList(closeDateDeal.editDate, userGroups)]
			this.form.automatic = closeDateDeal.automatic

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			closeDateDealData() {
				return {
					...this.form.closeDateDeal,
					viewDate: this.selectListToArray(this.form.viewDate),
					editDate: this.selectListToArray(this.form.editDate),
					automatic: this.form.automatic.length ? this.form.automatic : 'inactive',
				}
			},
		},

		methods: {
			getConfig,
			saveConfig,

			selectListToArray(selectList) {
				let list = []
				selectList.forEach((item) => {
					list.push(item.value)
				})
				return list
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig('closeDateDeal', this.closeDateDealData, 'value_long')

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
